import React from 'react';
import _ from 'lodash';
import { api, app } from 'xadmin';
import { C } from 'xadmin-ui';
import { Transfer } from 'antd';

const SelectDepartment = (props) => {

  const { input } = props

  const [ list, setList ] = React.useState([])
  const [ targetKeys, setTargetKeys ] = React.useState([])

  const fetchDepartment = (nodes) => {
    return new Promise ((resolve, reject) => {
      const schema = app.get('models')['Department']
      api(schema)
        .query({ fields: ['name', 'parent'] })
        .then(({ items }) => {
          if (items && !_.isEmpty(items)) {
            const department = items.map(item => { return { title: item.fullName, key: item.id}})
            setList(department)
            if (input?.value?.length) {
              setTargetKeys(input?.value)
            } else {
              setTargetKeys(department.map(item => item.key))
            }
            resolve()
          }
        })
    })
  }

  const onChange = (nextTargetKeys) => {
    setTargetKeys(nextTargetKeys)
    input.onChange(nextTargetKeys)
  }

  React.useEffect(() => {
    fetchDepartment()
  }, [])
  
  return <C is="Dashboard.FormModalButton" 
      title="选择"
      align="left"
      offset={100}
      width={500}
      compStyle={false}
    >
      <Transfer
        dataSource={list}
        titles={['未选', '已选']}
        targetKeys={targetKeys}
        onChange={onChange}
        render={item => item.title}
        listStyle={{
          height: '400px'
        }}
      />
    </C>
}

const filterDepartment = (items, selectDepartment) => {
  if (selectDepartment?.length) {
    const result = []
    for (let item of items) {
      if (selectDepartment.indexOf(item.id) !== -1) {
        result.push(item)
      }
    }
    return result
  } else {
    return items
  }
}

export { filterDepartment }

export default SelectDepartment
